<template>
	<div>
		<div class="msg_box">
			<div class="tech_title">文献下载</div>
			<div class="tech_select clearfloat">
				<div class="kuang search_long">
					<span class="el-icon-search"></span>
					<div class="searchInp">
						<el-input class="nav_search" v-model="searchVal" @change="tosearch" 
					 select-when-unmatched placeholder="按货号/产品名/其他搜索"></el-input>
					</div>
				</div>
				<div class="select">
					<el-select  @change="Postliterature();pageNo = 1;" class="chongsele" v-model="product_id" clearable placeholder="请选择产品">
						<el-option
						v-for="item in goodsList"
						:key="item.id"
						:label="item.model"
						:value="item.id" >
						<!-- :disabled="item.disabled" -->
						</el-option>
					</el-select>
				</div>
				<div class="select">
					<el-select @change="PostskillProduct" class="chongsele" v-model="category_id" clearable placeholder="请选择分类">
						<el-option
						v-for="item in classifyList"
						:key="item.id"
						:label="item.title"
						:value="item.id" >
						<!-- :disabled="item.disabled" -->
						</el-option>
					</el-select>
				</div>
			</div>
			<div class="min_he400" v-loading="loading">
				<div class="tech_box" v-for="item in literature" :key="item.id">
					<div class="box_title cur_po" @click="xin.goUrl('/oneDetails?cid='+item.id)">{{item.title}}</div>
					<div class="tech_zi" v-for="val in item.explain" :key="val.id">
						<span class="zi_name erjihuanhang cur_po" @click="xin.goUrl('/products/'+val.goods_id)">{{val.goods_title}}</span>
						<span class="zi_id">{{val.goods_model}}</span>
						<span class="zi_ton erjihuanhang">{{val.use}}</span>
						<span class=" zi_download" >
							<div @click="xin.goNew(val.file)" class=" laing_btn flo_right">文献下载</div>
						</span>
					</div>
				</div>
			</div>
			<div class="bottom_paging">
				<el-pagination class="feye" :background="true" :current-page.sync="pageNo" :page-size="limit" layout="prev, pager, next, jumper"
				:total="total" @current-change="pageCurrentChange" :hide-on-single-page="true"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default{
	data(){
		return {
			loading:true,
			searchVal:"",
			goodsList:[],//产品list
			title:'',//搜索值
			category_id:'',//分类id
			product_id:'',//产品id
			total:0,//总数量
			pageNo:1,//当前页
			limit:0,//一页多少条
			literature:{}
		}
	},
	created(){
		this.Postliterature();
	},
	computed: {
		...mapState(['classifyList']),
	},
	methods:{
		tosearch(e){//搜索
			e = e.replace(/\s+/g,"");
			this.title = e;
			this.Postliterature();
		},
		async PostskillProduct(category_id){//根据分类获取产品
			this.product_id ='';
			this.pageNo = 1;
			this.Postliterature();
			if(!category_id){
				this.goodsList = [];
				return;
			}
			let {data} = await this.api.PostskillProduct({category_id});
			this.goodsList = data;
		},
		async Postliterature(){//获取文献
			this.loading = true;
			let {pageNo,title,category_id,product_id} = this;
			let {data,msg,code} =  await this.api.Postliterature({page:pageNo,title,category_id,product_id});
			this.literature = data.data;
			this.total = data.total;
			this.limit = data.per_page;
			this.loading = false;
		},
		pageCurrentChange(val) {//分页查询
			this.pageNo = val;
			this.Postliterature();
		},
	}
}
</script>

<style lang="scss" scoped>
.chongsele{
	width: 100%;
	/deep/.el-input__inner{
		border-radius: 25px;
		height: 50px;
    	line-height: 50px;
	}
	/deep/.el-input__icon{
		line-height: 50px;
	}
}
.msg_box{
	.tech_select{
		.el-icon-search{
			
		}
		.searchInp{
			width: 230px;
		}
	}
}
.nav_search{
	/deep/.el-input__inner{
		border: none;
	}
}
</style>
